import { action as apiAction } from 'api/Api'

type Payload = {
  documentListId: number;
  documentTemplateSourceId: number;
  identifier: string;
}

const requestRemoveDocumentTemplate = (payload: Payload) => async () => {
  const { documentListId, documentTemplateSourceId, identifier } = payload

  try {
    await apiAction('RemoveDocumentTemplate', {
      documentsContainerId: documentListId,
      documentTemplateSourceId,
      identifier,
    })
  } catch (error) {
    if (error.code !== 401) { // Not found
      throw error
    }
  }
}

export default requestRemoveDocumentTemplate
